import React, { useState, useEffect } from "react";
import {
  Card,
  Modal,
  Form,
  Button,
  Tab,
  Row,
  Nav,
  Spinner,
} from "@themesberg/react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  editarTratamientoAction,
  cerrarModalEditarAction,
} from "../../actions/tratamientosActions";
import { getBase64 } from "../../helpers";
import DatosAdicionalesRender from "../../components/DatosAdicionales/DatosAdicionalesRender";

export default (props) => {
  const dispatch = useDispatch();

  const { tratamiento, showModalEditar } = useSelector(
    (state) => state.tratamientos
  );
  const { datosAdicionales, tabsDatosAdicionales } = useSelector(
    (state) => state.datosAdicionales
  );
  const { datosAdicionalesDetalles, loadingDatosAdicionalesDetalles } =
    useSelector((state) => state.datosAdicionalesDetalles);

  const [
    datosAdicionalesDetallesCargados,
    setDatosAdicionalesDetallesCargados,
  ] = useState(false);

  const [edicion, guardar] = useState({
    nombre: "",
    imagen: null,
  });

  useEffect(() => {
    setDatosAdicionalesDetallesCargados(
      loadingDatosAdicionalesDetalles === false
    );
  }, [loadingDatosAdicionalesDetalles]);

  useEffect(() => {
    guardar({ ...tratamiento, imagen: null });
  }, [tratamiento]);

  const submitForm = (e) => {
    e.preventDefault();

    const datos_adicionales = {
      detalles: datosAdicionalesDetalles,
      tabla: "TRATAMIENTOS",
      id_tabla: edicion.id,
    };
    edicion.datos_adicionales = datos_adicionales;

    dispatch(editarTratamientoAction(edicion));
  };

  const handleClose = () => {
    dispatch(cerrarModalEditarAction());
  };

  const onChangeForm = (e) => {
    guardar({
      ...edicion,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeFileForm = (e) => {
    getBase64(e.target.files[0], (result) => {
      guardar({
        ...edicion,
        imagen: result,
      });
    });

    guardar({
      ...edicion,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal
      as={Modal.Dialog}
      centered
      show={showModalEditar}
      onHide={handleClose}
    >
      <Modal.Header>
        <Modal.Title className="h6">Editar Tratamiento</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Form onSubmit={submitForm}>
        <Modal.Body>
          <Tab.Container defaultActiveKey="generales">
            <Row>
              <Nav fill variant="tabs" className="mb-3">
                <Nav.Item>
                  <Nav.Link eventKey="generales">Generales</Nav.Link>
                </Nav.Item>
                {tabsDatosAdicionales.map((dato, index) => (
                  <Nav.Item>
                    <Nav.Link eventKey={dato.tabulador}>
                      {dato.tabulador}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Row>
            <Tab.Content>
              <Tab.Pane eventKey="generales" title="Generales">
                <Form.Group className="mb-3">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    name="nombre"
                    placeholder="Nombre tratamiento"
                    value={edicion.nombre}
                    onChange={onChangeForm}
                  />
                </Form.Group>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Imagen</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={onChangeFileForm}
                    name="imagen"
                    accept=".png,.jpg,.jpeg,.gif"
                  />
                </Form.Group>
              </Tab.Pane>
              {tabsDatosAdicionales.map((dato, index) => (
                <Tab.Pane
                  eventKey={dato.tabulador}
                  title={dato.tabulador}
                  key={index}
                >
                  {datosAdicionalesDetallesCargados === true ? (
                    <>
                      <DatosAdicionalesRender
                        tabulador={dato.tabulador}
                        id_tabla={edicion.id}
                      />
                    </>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  )}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="link"
            className="text-gray ms-auto"
            onClick={handleClose}
          >
            Cerrar
          </Button>
          <Button type="submit" variant="secondary">
            Actualizar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
